import type { RowData } from "@tanstack/react-table";
import clsx from "clsx";
import { type JSX, memo, useMemo } from "react";

import styles from "../styles.module.scss";

import type { ITableBodyProps } from "@components/organisms/table/types";
import { RowComponent } from "@components/organisms/table/tbody/rowComponent";
import type { IWithId } from "@components/organisms/formListBox";

export const Tbody = memo(function Tbody<TData extends RowData>({
  rows,
  showRow,
  hasActionCell,
}: ITableBodyProps<TData>) {
  const rowsComponent = useMemo(
    () =>
      rows?.map((rowEl, index) => {
        return (
          <RowComponent
            key={`${(rowEl.original as IWithId<object>).id || rowEl.id}`}
            rowEl={rowEl}
            index={index}
            showRow={showRow}
          />
        );
      }),
    [rows, showRow],
  );

  return (
    <tbody
      className={clsx([
        styles.tbody,
        showRow && styles.rowCell,
        hasActionCell && styles.actionCell,
      ])}
    >
      {rowsComponent}
    </tbody>
  );
}) as <TData extends RowData>(props: ITableBodyProps<TData>) => JSX.Element;
